<script>
export default {
    name: "VHeadline",
    render: function(createElement) {
        return createElement(
            "h" + this.level,
            {
                class: this.className,
                attrs: {}
            },
            this.$slots.default
        );
    },
    props: {
        level: {
            type: Number,
            default: 1
        }
    },
    computed: {
        className: function() {
            return "headline-h" + this.level;
        }
    }
};
</script>

<style scoped lang="scss">
.headline-h1 {
    font-size: 3.3rem;
    font-weight: 500;
    display: inline-block;
    letter-spacing: 2px;
}
.headline-h2 {
    font-size: 3.3rem;
    font-weight: 500;
    display: inline-block;
    letter-spacing: 2px;
}
.headline-h3 {
}
.headline-h4 {
}
.headline-h5 {
}
.headline-h6 {
}
</style>


<style scoped lang="scss">


@media (max-width: 680px) {
    .headline-h1, .headline-h2 {
        font-size: 2.7rem;
    }
}


@media (max-width: 565px) {
    .headline-h1, .headline-h2 {
        font-size: 2.4rem;
    }

    .headline-h3{
        font-size: 1.6rem;
    }
}

@media (max-width: 500px) {
    .headline-h1, .headline-h2 {
        font-size: 2.1rem;
    }
}

@media (max-width: 375px), (max-width: 414px) {
    .headline-h1, .headline-h2 {
        font-size: 1.6rem;
    }

    .headline-h3 {
        font-size: 1.5rem;
    }
}




</style>